export const NAME = 'writers';
export const LEVEL_ONE = 'WritersComponentReducer';
